// extracted by mini-css-extract-plugin
module.exports = {"c-product-card":"product-card-image-carousel_c-product-card__ctk8d","Carousel_button":"product-card-image-carousel_Carousel_button__OKf6R"};